import { Locales } from 'src/lib/constants';
import { getBlogPostPaths, getBlogPostProps } from 'src/lib/blog-page-data';
import BlogPostPage from 'src/components/Blog/Pages/BlogPostPage';

export const getStaticPaths = () => {
  return getBlogPostPaths({ locale: Locales.EN_GB });
};

export const getStaticProps = ({ params, preview }) => {
  return getBlogPostProps({
    locale: Locales.EN_GB,
    post: params.post,
    preview,
  });
};

export default BlogPostPage;
